<template>
    
<div class="charpter_one " >
    <div class="mt-5 p-5">
    <h1  class="font-weight-bolder">Introducción</h1>
    <p class="mt-5">
        “Caminante no hay camino, se hace camino al andar” esta y otras frases
        se escuchan muy frecuentemente en el argot popular y si vamos a hablar
        sobre la capacidad de ser autodidactas, esta frase encaja muy bien.
        Cuando tenemos la capacidad de ser autodidactas somo nosotros mismos
        quienes trazamos nuestros caminos, caminos que son inciertos y que a
        veces nos meten en callejones sin salida, pero ser autodidacta no es
        malo, por el contrario, ser autodidacta es una gran ventaja. Una de las
        características principales que debe tener un autodidacta es ser
        perseverante y tenaz.
      </p>
      <p>
        En esta serie de artículos iré contando muy detalladamente todos los
        pasos que realicé para convertirme en un desarrollador web de manera
        autodidacta, contaré los tropiezos, los fallos y los momentos de
        frustración a los que me he enfrentado en este largo trajinar, y todo
        esto no lo hago con el fin de desanimarte, sino por el contrario, para
        que te des cuenta que si yo lo hice, como no lo podrás hacer tú que
        posiblemente eres más capaz. Las razones por las cuales nos volvemos
        autodidactas son muy diferentes y tu conoces la tuya, pero aun así
        compartiré cual fue mi principal razón.
      </p>
      <p>
        Hace más de 5 años salí de mi país de origen a enfrentarme a un país de
        costumbres muy diferentes, donde aprendí muchas cosas. Estando allí
        descubrí mi capacidad de estudiar solo y sin salir de casa. Las
        circunstancias me hicieron buscar la manera de seguir creciendo
        intelectualmente y dado que mi condición legal en aquel país pasó a ser
        irregular por falta de un permiso de residencia. Me vi forzado a buscar
        otros medios de educación alternativos, porque a los medios
        tradicionales de educación me era muy difícil acceder. De modo que en
        vez de quejarme de mi situación y gracias a las facilidades que ahora
        nos brinda el internet pude empezar a construir mi camino y así dar lo
        mejor de mí, dejar mi pellejo por alcanzar mis metas y lograr
        convertirme en esto que tanto he soñado y que me apasiona. Para no
        ahondar más en este tema y no cansarte con tanta palabrería, pasemos a
        lo realmente importante.
      </p>
      <p>
        No porque yo sea autodidacta, me voy a vanagloriar, pero cuando una
        persona tiene la capacidad de ser autodidacta tiene una gran ventaja
        comparado con los demás dado que estas personas, no se rinden con
        facilidad y más aún cuando de programar se trata. Y otra razón que he
        podido notar, es que cuando una persona es autodidacta, esta persona se
        enfoca y se esfuerza para mejorar, y en este proceso de desarrollo de
        las aptitudes se desarrolla una gran fuerza que les permite llegar muy
        lejos y no detenerse, aun, cuando la frustración nos llega, esta fuerza
        es conocida como “Pasión”, cuando haces lo que te apasiona no lo haces
        por obligación. Cuando haces lo que te apasiona, eres persistente y eres
        tenaz.
      </p>
      <p>
        En esta serie de textos iré dándote pautas y una hoja de ruta para que
        te conviertas en un desarrollador web. Basándome en mi experiencia hice
        un análisis de mis falencias y los puntos débiles y fallas que como
        autodidacta cometí. No soy un gurú en estos temas. Pero quiero que tú
        que estás pensando en iniciarte en esta profesión y no sabes por dónde
        empezar, tú que tienes las ganas, pero te asusta lanzarte al vacío por
        el temor al fracaso, por esta y muchas otras razones he decido compartir
        este proyecto, para ayudarte a encaminarte en el mundo de la
        programación.
      </p>
      <p>
        Cuando yo empecé a programar me inicié como muchos lo han hecho, muchos
        empezaron a aprender solos, sin tutores, profesores etc. Cuando yo me
        inicié no tenía una hoja de ruta, así que empecé aprender a programar
        utilizando un lenguaje de programación, en mi caso comencé con Java. No
        quiero decir que esto sea una mala práctica, porque hay cantidad de
        tutoriales en YouTube y otras plataformas en línea donde dictan
        videotutoriales y los docentes utilizan lenguajes de programación para
        enseñar a programar de una manera muy efectiva. Pero debemos ser
        conscientes de que todos tenemos formas diferentes de aprendizaje unos
        son más rápidos para captar y tienen una lógica más desarrollada, pero
        en mi caso esto me dificultó el proceso de aprendizaje, porque cuando
        empecé a escribir pequeños programas no entendía cómo funcionaba el
        código. Así que mi primera sugerencia es la siguiente:
      </p>
      <p>
        Si quieres aprender a programar no utilices ningún lenguaje de
        programación. Yo sé que cuando uno empieza a ver como se ve el código en
        la pantalla del computador uno quisiera tirar miles y miles de líneas de
        código. No comas ansias recuerda “Despacio que llevo prisa”. Existen dos
        herramientas que yo te recomiendo para empezar:
      </p>
      <ol>
        <li><h4 class="font-weight-bolder">Pseudocódigo</h4></li>
        <p>
          O lenguaje de descripción algorítmico, este lenguaje nos permite
          aprender y ver como se estructuran los algoritmos de manera manual lo
          cual permite un mayor entendimiento de cómo funcionan los programas
          computacionales. <span class="text-exam">Ejemplo de algoritmo creado en pseudocódigo</span>
        </p>
        <img src="../assets/images/pseudo.png" alt="pseudocodigo" class="img-pseudo" />
        <li><h4 class="font-weight-bolder">Diagramas de flujo</h4></li>
        <p>
          Estos nos permiten crear algoritmos de manera gráfica lo cual nos
          permite entender el funcionamiento y más cuando estamos aprendiendo
          cómo funcionan los condicionales (IF y ELSE) y los bucles (FOR, WHILE,
          DO WHILE) elementos muy utilizados en el desarrollo de software.
          <span class="text-exam">Ejemplo de algoritmo creado con diagramas de flujo</span>
        </p>
       <img
          src="../assets/images/diagrama.png"
          alt="diagrama-de-flujo"
          class="img-diagrama "
        />
        </ol>
        <p>
          Las razones por las cuales te sugiero estas dos herramientas es porque
          en el momento en que ya empieces a trabajar con los lenguajes de
          programación vas a tener un conocimiento previo y probablemente ya
          habrás escrito algunos programas, lo cual esto te permite ir
          desarrollando la lógica de la programación y así darás pasos más
          firmes en tu proceso de aprendizaje.
        </p>
      
      <p>
        En YouTube existe un canal donde el profesor enseña a programar sin
        utilizar lenguaje de programación alguno y en cambio utiliza una
        metodología donde emplea un programa llamado Raptor, el cual permite al
        estudiante desarrollar algoritmos utilizando los diagramas de flujo. Una
        vez hayas aprendido los básico de cómo funcionan los lenguajes de
        programación y la forma de realizar los algoritmos para la solución de
        problemas, empieza a utilizar un lenguaje de programación. El que sea de
        tu agrado. Como ya has estudiado previamente y estás familiarizado con
        la declaración de variables, uso de sentencias condicionales, bucles
        etc. Es momento de conocer y aprender la sintaxis básica del lenguaje de
        programación que más te guste. Yo personalmente te recomendaría
        JavaScript si lo que más te llama la atención es el desarrollo web.
        Programar no es fácil, pero tampoco es imposible. Si quieres ser un buen
        desarrollador debes ser muy constante recuerda " los grandes esfuerzos
        generan grandes resultados" se constante, y si no entiendes busca
        diferentes fuentes de documentación. A medida que vas estudiando por tu
        propia cuenta vas aprendiendo a conocerte, poco a poco te iras dando
        cuenta de cuáles son las formas y las metodologías más eficaces, que te
        permiten avanzar en tu aprendizaje. Por esto al principio de este
        artículo te dije que un autodidacta debía ser perseverante y tenaz.
        Cuando de educación se trata y en especial en programación sea cual sea
        el enfoque, Front - End o Backend, me he dado cuenta que en el momento
        en que abres la primera puerta y echas un vistazo al lado derecho, al
        lado izquierdo, al frente, arriba y abajo y en todos lados; hay más
        puertas que poco a poco tendrás que ir abriendo.
      </p>
    
  
    </div>
</div>

</template>
<script>
export default {
name: "charpter_one",
props:{
   

    
}
   
      

    
}

</script>


<style lang="scss" scoped>
p,li{
  
  font-size: 20px;;

}
.img-diagrama{
  width:400px;
}
@media only screen and (max-width: 600px) {
  
  .img-diagrama, .img-pseudo {
    width: 80%;
  }
}

</style>